import axios from 'axios'
import { EMPLOYEE_URL, MOBILE_EMPLOYEE_URL } from './api'
import { authorizationHelper } from '../common/helpers'

export function getAll(page, filter, store_id) {
    const params = {
        page,
        filter,
        store_id
    }

    return axios.get(EMPLOYEE_URL, {
        params,
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function getAllWithSize(page, filter, size) {
    const params = {
        page,
        filter,
        size
    }

    return axios.get(EMPLOYEE_URL, {
        params,
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function get(id) {
    const url = `${EMPLOYEE_URL}/${id}`

    return axios.get(url, {
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function create(employee) {
    return axios.post(EMPLOYEE_URL, employee, {
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function uploadPhoto(id, photo) {
    let data = new FormData();
    data.append('photo', photo);

    const url = `${EMPLOYEE_URL}/${id}/photo`

    return axios.put(url, data, {
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function deletePhoto(id) {
    const url = `${EMPLOYEE_URL}/${id}/photo`

    return axios.delete(url, {
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function update(id, employee) {
    const url = `${EMPLOYEE_URL}/${id}`

    return axios.put(url, employee, {
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function updateState(id, isActive) {
    const url = `${EMPLOYEE_URL}/${id}/activate`
    const params = {
        isActive
    }
    return axios.put(url, null, {
        params,
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function deleteEmployee(id) {
    const url = `${EMPLOYEE_URL}/${id}`

    return axios.delete(url, {
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function getSells(page, startDate, endDate, id) {
    const params = {
        page,
        startDate,
        endDate
    }
    const url = `${EMPLOYEE_URL}/services/${id}`

    return axios.get(url, {
        params,
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function getItemSells(page, startDate, endDate, id) {
    const params = {
        page,
        startDate,
        endDate
    }
    const url = `${EMPLOYEE_URL}/items/${id}`

    return axios.get(url, {
        params,
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}


export function getEmployeesByStore(store_id) {
    const url = `${MOBILE_EMPLOYEE_URL}/store/${store_id || 0}`
    return axios.get(url, {
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}


// WEBPACK FOOTER //
// ./src/service/employee.js